module.exports = __webpack_public_path__ + "static/media/icon-external-link.a3e1b1fe.svg";